import React from "react";

/*function createMarkup(html) {
  return { __html: html };
}*/

const Grouping = ({ players, str }) => {
	let lis = players.map((item, index) => {
		let imgClass = "highlight-search-on";
		if (str.length > 0) {
			imgClass = "highlight-search-off";
			if (item.lname.toLowerCase().substring(0, str.length) === str) {
				imgClass = "highlight-search-on";
			}
		}
		imgClass += " image-shadow";

		return (
			<li key={item.id}>
				<div style={{ position: "relative" }}>
					<img
						className={imgClass}
						src={item.img}
						alt={`${item.fname} ${item.lname}`}
					/>
					<div className="name-appearances">
						<span>{`${item.fname} ${item.lname}`}</span>
						<br />
						<span className="hometown">{item.locale}</span>
					</div>
					<div
						style={{
							width: "15%",
							position: "absolute",
							top: "5px",
							right: "5px",
						}}
					>
						<img
							className="image-shadow"
							style={{ maxWidth: "100%", display: "block" }}
							src={`https://qnmcdn.qnm.workers.dev/tourneyweb.com/?path=%2Fassets%2Fflag-icons%2F${item.country}.png&ma=86400`}
							alt={item.country}
						/>
					</div>
				</div>
			</li>
		);
	});

	return <ul className="teetimes">{lis}</ul>;
};

export default Grouping;



// WEBPACK FOOTER //
// ./src/Grouping.js